<template>
  <div ref="grid" class="MASONRY-COLUMNS">
    <slot :calculateCellPositions="debouncedOnWindowResize" />
  </div>
</template>

<script>
import _noop from 'lodash/noop';
import _debounce from 'lodash/debounce';

export default {
  name: 'masonry-columns',
  data () {
    return {
      debouncedOnWindowResize: _noop,
    };
  },
  mounted () {
    this.debouncedOnWindowResize = _debounce(this.calculateCellPositions, 6);

    global.addEventListener('resize', this.debouncedOnWindowResize);

    this.calculateCellPositions();
  },
  updated () {
    this.calculateCellPositions();
  },
  destroyed () {
    global.removeEventListener('resize', this.debouncedOnWindowResize);
  },
  methods: {
    calculateCellPositions () {
      if (!this.$refs.grid) {
        return;
      }

      const {
        gridAutoRows: gridAutoRowsPx,
        gridRowGap: gridRowGapPx,
      } = global.getComputedStyle(this.$refs.grid);
      const gridAutoRows = parseInt(gridAutoRowsPx, 10);
      const gridRowGap = parseInt(gridRowGapPx, 10);

      this.$refs.grid
        .querySelectorAll('[data-masonry-columns-cell]')
        .forEach((el) => {
          const { height } = el
            .querySelector('[data-masonry-columns-cell-content]')
            .getBoundingClientRect();

          el.style.gridRowEnd = `span ${Math.ceil(
            height / (gridAutoRows + gridRowGap)
          )}`;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .MASONRY-COLUMNS {
    @include responsive(
      grid-template-columns,
      1fr,
      $lg: repeat(2, minmax(256px, 345px))
    );
    display: grid;
    width: 100%;
    grid-auto-rows: $unit/2;
    grid-auto-flow: dense;
    grid-row-gap: 0;
    grid-column-gap: 4*$unit;
  }
</style>
